__webpack_require__.p = "/stroke-prediction/";